import { colors } from 'ui/theme/colors';
import { ArrowUp } from 'ui/icons/analytics/ArrowUp';
import { ArrowDown } from 'ui/icons/analytics/ArrowDown';
import { Dash } from './Styled';

export const getPercentChangeInfo = (value: number, previousValue: number) => {
  const valueIncreased = value > previousValue;
  const valueDecreased = value < previousValue;
  const noDelta = value === previousValue;

  let percentChange = 0;
  let icon = null;
  let iconBackgroundColor = '';
  let iconColor = '';

  switch (true) {
    case valueIncreased:
      percentChange = (value - previousValue) / previousValue;
      iconColor = colors.green100;
      iconBackgroundColor = colors.green10;
      icon = <ArrowUp color={iconColor} backgroundColor={iconBackgroundColor} />;
      break;
    case valueDecreased:
      percentChange = (previousValue - value) / previousValue;
      iconColor = colors.red100;
      iconBackgroundColor = colors.red10;
      icon = <ArrowDown color={iconColor} backgroundColor={iconBackgroundColor} />;
      break;
    case noDelta:
      percentChange = 0;
      iconColor = colors.grey80;
      iconBackgroundColor = colors.grey5;
      icon = <Dash />;
      break;
    default:
  }

  return {
    percentChange,
    icon,
    iconBackgroundColor,
    iconColor,
  };
};
